import React, { useState } from 'react';
import { CategoryCardView, CategoryCardViewProps } from './CategoryCard.view';
import { showToast } from '../../../../helpers/showToast';

export type CategoryCardControllerProps = Omit<
  CategoryCardViewProps,
  | 'openDeleteCategoryModal'
  | 'setOpenDeleteCategoryModal'
  | 'openEditCategoryModal'
  | 'setOpenEditCategoryModal'
  | 'openUnArchiveCategoryModal'
  | 'unArchiveCategoryHandler'
  | 'setOpenUnArchiveCategoryModal'
  | 'archiveDeleteCategoryHandler'
> & {
  // extend your CategoryCardViewProps
};

export const CategoryCardController = (props: CategoryCardControllerProps): JSX.Element => {
  const [openDeleteCategoryModal, setOpenDeleteCategoryModal] = useState<boolean>(false);
  const [openEditCategoryModal, setOpenEditCategoryModal] = useState<boolean>(false);
  const [openUnArchiveCategoryModal, setOpenUnArchiveCategoryModal] = useState<boolean>(false);

  const archiveDeleteCategoryHandler = () => {
    if (!props.category.archived && props.isLastCategory) {
      showToast({
        summary: 'Unable to archive last Category',
        detail: "The last remaining Category can't be archived.",
        severity: 'error'
      });
    } else {
      setOpenDeleteCategoryModal(true);
    }
  };

  const unArchiveCategoryHandler = () => {
    setOpenUnArchiveCategoryModal(true);
  };

  const viewProps: CategoryCardViewProps = {
    ...props,
    openDeleteCategoryModal,
    setOpenDeleteCategoryModal,
    openEditCategoryModal,
    setOpenEditCategoryModal,
    openUnArchiveCategoryModal,
    setOpenUnArchiveCategoryModal,
    archiveDeleteCategoryHandler,
    unArchiveCategoryHandler
  };
  return <CategoryCardView {...viewProps} />;
};
